import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "../Base/BaseService";
import { SessionStorageService } from "../sessionStorageService/session-storage.service";
import { AuthService } from "../Interceptor/auth.service";

@Injectable({
  providedIn: "root",
})
export class MauroService extends BaseService {
  constructor(public http: HttpClient, public lsService : SessionStorageService, authService: AuthService) { 
    super(http, lsService,authService);
    this.Component = "MauroService";
  }

  public async postMauro(data){
    await this.PostData(data,"Mauro","Post").then((res) => {
      if(res.head.status != 'False') {
      }
    });
    return true;
  }


}
